import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot, UrlSegment, Router } from '@angular/router';
import { of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { map, tap } from 'rxjs/operators';
import { HomeService } from 'src/app/home/home.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  userValidation: any;

  constructor(private authService: AuthService,
              public router: Router,
              private homeService: HomeService ) {}
  
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const tokenStr: string | null = localStorage.getItem('tokenObj');
    if (tokenStr){
      return this.homeService.validateUserPermission().pipe(map(data => {
        this.userValidation = data;
        if(this.userValidation.validationStatus !== 'OK'){
            localStorage.clear();
            this.router.navigate(['/login']);
            return false;
        }

        return true;
      }));
    } else {
      localStorage.clear();
      this.router.navigate(['/login']);
      return of(false);
    }
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]) {
    
    return this.authService.verifyAuthentication()
      .pipe(
        tap(isAuth => {
          if (!isAuth) {
            this.router.navigate(['./auth/login'])
          }
        })
      )
  }
}
